"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.loadableLib = exports.loadableTimeout = exports.loadableDelay = exports.loadable = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _component = _interopRequireDefault(require("@loadable/component"));

var _pMinDelay = _interopRequireDefault(require("p-min-delay"));

var _promiseTimeout = require("promise-timeout");

var _LoadSpinner = require("./LoadSpinner");

// https://github.com/gregberge/loadable-components

/**
 * 组件导入函数,支持自定义加载动画
 * @param {Function} func 返回动态引入的函数, 如 ()=>import('./a/b/c')
 * @param {Object} options {spinner:spinner, // loading动画组件, 默认为loadSpinner, 其他参数参考LoadSpinner组件}
 * @returns {Component}
 */
var loadable = function loadable(func, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      spinner = _options.spinner,
      restOptions = (0, _objectWithoutPropertiesLoose2["default"])(_options, ["spinner"]);
  return (0, _component["default"])(func, {
    fallback: (0, _LoadSpinner.loadSpinner)(spinner, restOptions)
  });
};
/**
 * 组件导入函数,支持延时加载
 * @param {Promise} promise 动态引入的返回值, 如 import('./a/b/c')
 * @param {Object} options {spinner:spinner, // loading动画组件, 默认为loadSpinner, delay:200, // 延迟时间, 默认200ms, 其他参数参考LoadSpinner组件}
 * @returns {Component}
 */


exports.loadable = loadable;

var loadableDelay = function loadableDelay(promise, options) {
  if (options === void 0) {
    options = {};
  }

  var _options2 = options,
      spinner = _options2.spinner,
      _options2$delay = _options2.delay,
      delay = _options2$delay === void 0 ? 200 : _options2$delay,
      restOptions = (0, _objectWithoutPropertiesLoose2["default"])(_options2, ["spinner", "delay"]);
  return (0, _component["default"])(function () {
    return (0, _pMinDelay["default"])(promise, delay);
  }, {
    fallback: (0, _LoadSpinner.loadSpinner)(spinner, restOptions)
  });
};
/**
 * 组件导入函数,支持加载超时
 * @param {Promise} promise 动态引入的返回值, 如 import('./a/b/c')
 * @param {Object} options {spinner:spinner, // loading动画组件, 默认为loadSpinner, time:200, // 过期时间, 默认5000ms, 其他参数参考LoadSpinner组件}
 * @returns {Component}
 */


exports.loadableDelay = loadableDelay;

var loadableTimeout = function loadableTimeout(promise, options) {
  if (options === void 0) {
    options = {
      time: 5000
    };
  }

  var _options3 = options,
      spinner = _options3.spinner,
      _options3$time = _options3.time,
      time = _options3$time === void 0 ? 5000 : _options3$time,
      restOptions = (0, _objectWithoutPropertiesLoose2["default"])(_options3, ["spinner", "time"]);
  return (0, _component["default"])(function () {
    return (0, _promiseTimeout.timeout)(promise, time);
  }, {
    fallback: (0, _LoadSpinner.loadSpinner)(spinner, restOptions)
  });
};
/**
 * lib动态导入函数
 * @param {Function} func 返回动态引入的函数, 如 ()=>import('abc')
 */


exports.loadableTimeout = loadableTimeout;
var loadableLib = _component["default"].lib;
exports.loadableLib = loadableLib;